<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-5">ACKNOWLEDGMENTS</p>
<p class="BT1stPara ParaOverride-7"><span class="CharOverride-5">Cardiff, by the Sea </span>first appeared in <span class="CharOverride-5">Ellery Queen.</span></p>
<p class="BT1stPara ParaOverride-9"><span class="CharOverride-5">Miao Dao </span>was an Amazon original.</p>
<p class="BT1stPara ParaOverride-9"><span class="CharOverride-5">Phantomwise: 1972 </span>first appeared in <span class="CharOverride-5">Ellery Queen</span> and was reprinted in <span class="CharOverride-5">The Best American Mystery Stories 2019.</span></p>
<p class="BT1stPara ParaOverride-9"><span class="CharOverride-5">The Surviving Child </span>first appeared in<span class="CharOverride-5"> Echoes: The Saga Anthology of Ghost Stories </span>and was reprinted in <span class="CharOverride-5">The Best Fantasy and Horror 2020.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802158017-4.vue?594d5c24